import {Environment, getEnvironment} from '@/services/infrastructure/envhelper.service'
import {ref} from 'vue'
import {TogglableFeature} from '@/feature-toggles/feature-toggler.service'

const devModeOverride = ref(false)

// @ts-ignore
window.enableFakeOrgMetrics = (enabled: boolean) => {
    devModeOverride.value = enabled
}

export const OrgCreateFeature: TogglableFeature = {
    isEnabled: () => {
        return getEnvironment() === Environment.Local
    }
}

export const FakeOrgMetrics: TogglableFeature = {
    isEnabled: () => {
        return devModeOverride.value
    }
}

export const ShowTenantId: TogglableFeature = {
    isEnabled: () => {
        return getEnvironment() === Environment.Local
    }
}

export const ShowDebtCollection: TogglableFeature = {
    isEnabled: () => {
        return true
    }
}